export default "__VITE_ASSET__r7w2xqNw__"